export const DE_DE = 'de-DE';
export const EN_GB = 'en-GB';
export const NL_NL = 'nl-NL';
export const EN_US = 'en-US';

export enum LOCALE {
  DE = DE_DE,
  EN = EN_GB,
  NL = NL_NL,
  US = EN_US
}

export const isValidLocale = (locale: string): boolean => {
    const options: string[] = Object.values(LOCALE);

    return options.includes(locale);
}
